// src/pages/MyBookingPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PropertyBookings from "../components/PropertyBookings";

const PropertyBookingsPage = () => {
  return (
    <>
      <Header />
      <PropertyBookings />
      <Footer />
    </>
  );
};

export default PropertyBookingsPage;
